import SkeletonCard from "../../skeletons/SkeletonCard";

const CardAvailableExchangeSkeleton = () => {
  return (
    <div className="p-3 bg-[#F2F4F8] rounded-lg flex items-center justify-between ">
      <div className="flex items-center">
        <SkeletonCard
          type="rectangle"
          rectangleWidth={65}
          rectangleHeight={65}
        />

        <div className="ml-3">
          <h3 className="font-semibold text-gray-800 text-base">
            <SkeletonCard
              type="text"
              lines={2}
              widths={["60px", "40px"]}
              heights={["10px", "10px"]}
            />
          </h3>
        </div>
      </div>

      <div className="!flex !flex-col sm:flex-row sm:items-center gap-3">
        {/* <SkeletonCard
          type="text"
          lines={1}
          widths={["80px"]}
          heights={["20px"]}
        />
        <SkeletonCard
          type="text"
          lines={1}
          widths={["80px"]}
          heights={["20px"]}
        /> */}
      </div>
    </div>
  );
};

export default CardAvailableExchangeSkeleton;
